var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delivery-info-container" },
    [
      _c(
        "el-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [_c("TitleItem", { attrs: { title: "配送信息" } })]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            {
              ref: "deliveryInfoForm",
              attrs: {
                model: _vm.deliveryInfoModel,
                rules: _vm.deliveryInfoRules,
                "label-width": "125px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "0" },
                  attrs: { label: "配送模板", prop: "deliveryTemplateId" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.deliveryInfoModel.deliveryTemplateId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.deliveryInfoModel,
                            "deliveryTemplateId",
                            $$v
                          )
                        },
                        expression: "deliveryInfoModel.deliveryTemplateId"
                      }
                    },
                    _vm._l(_vm.deliveryTemplateList, function(deliveryModel) {
                      return _c("el-option", {
                        key: deliveryModel.id,
                        attrs: {
                          label: deliveryModel.name,
                          value: deliveryModel.id
                        }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "15px" },
                      attrs: { type: "text" },
                      on: { click: _vm.manageDeliveryTempClick }
                    },
                    [_vm._v("管理模板")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { color: "grey" },
                      attrs: { type: "text" },
                      on: { click: _vm.refreshDeliveryTempClick }
                    },
                    [_vm._v("刷新")]
                  ),
                  !_vm.deliveryInfoModel.deliveryTemplateId
                    ? _c("p", { staticClass: "tempTips" }, [
                        _vm._v("请先选择配送模板")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm.is_delivery_area_goods == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": "1", "false-label": "0" },
                          model: {
                            value: _vm.deliveryInfoModel.isDeliveryAreaGoods,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.deliveryInfoModel,
                                "isDeliveryAreaGoods",
                                $$v
                              )
                            },
                            expression: "deliveryInfoModel.isDeliveryAreaGoods"
                          }
                        },
                        [_vm._v("仅配送区域内展示商品")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "运费模板", prop: "shopFreightTemplateId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.deliveryInfoModel.shopFreightTemplateId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.deliveryInfoModel,
                            "shopFreightTemplateId",
                            $$v
                          )
                        },
                        expression: "deliveryInfoModel.shopFreightTemplateId"
                      }
                    },
                    _vm._l(_vm.freightFormworkList, function(freightModel) {
                      return _c("el-option", {
                        key: freightModel.id,
                        attrs: {
                          label: freightModel.name,
                          value: freightModel.id
                        }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "15px" },
                      attrs: { type: "text" },
                      on: { click: _vm.manageDeliveryMoneyTempClick }
                    },
                    [_vm._v("管理模板")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { color: "grey" },
                      attrs: { type: "text" },
                      on: { click: _vm.refreshDeliveryMoneyTempClick }
                    },
                    [_vm._v("刷新")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }